module.exports = __webpack_public_path__ + "img/slogo.6739190a.png";